// ★★★ PC-6 P6 — decisões de TELA sobre a posse do lead. Puro, só no web.
//
// ⚠ Fica FORA de `leads/posse.js` de propósito: aquele é espelho do servidor (o teste exige os
// mesmos exports dos dois lados), e o que mora aqui não existe no servidor — é como a TELA mostra.

import { quantasSdrsAtivas } from '@/equipe/funcoes';

/** Gestor e superadmin passam por cima da trava (D5); o resto é SDR para a tela. */
export const ehGestor = (papel) => papel === 'gestor' || papel === 'superadmin';

/**
 * ★★ Clínica com UMA SDR só (decisão do dono, 24/10): "não precisa ficar aparecendo aquela
 * mensagem de lead reservado… porque só tem uma pessoa cadastrada". Conta quem tem o PAPEL `sdr`
 * e está ativo — ⚠ não `apenasSdrs`, que inclui o gestor pela função derivada.
 */
export const clinicaDeUmaSdr = (equipe = []) => quantasSdrsAtivas(equipe) <= 1;

/**
 * O texto da situação aparece? ★ Na clínica de 1 SDR, os textos de RESERVA/TRAVA somem — o
 * comportamento continua (a callable decide igual), só o texto não aparece. O que orienta
 * ("assuma e agende", "Este lead é seu.") continua.
 */
export const mostrarTextoDaPosse = (situacao, equipe) =>
  Boolean(situacao?.texto) && !(situacao.estado === 'travado' && clinicaDeUmaSdr(equipe));

/**
 * ★ AGENDA (dono, 24/10): agendando um lead que NÃO é de quem agenda —
 *   liberado → o botão vira "Assumir e agendar" (assume pela callable e depois agenda);
 *   travado  → aviso com o motivo; NÃO bloqueia (nem o gestor, nem a SDR que ajuda a colega:
 *              o lead continua com a dona, e a comissão também).
 */
export function agendandoLeadDeOutra(situacao) {
  if (!situacao || situacao.estado === 'seu') return null;
  if (situacao.estado === 'liberado') return { assumirAntes: true, aviso: null };
  const dona = situacao.dona?.nome || 'outra pessoa';
  return { assumirAntes: false, aviso: `${situacao.texto} Se você agendar, o lead continua com ${dona}.` };
}
